module.exports = __webpack_public_path__ + "img/trips-1-mobile.340ed7c9.gif";